import { Link } from "react-router-dom";

import AuthPageTitle from "@/components/layout/auth-page-title";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const ResetPasswordSuccessPage = () => {
  return (
    <div className="grid grid-flow-row grid-cols-1 gap-12 pr-[112px] pl-[112px] w-full">
      <AuthPageTitle
        title="Mot de passe confirmé"
        subTitle="Votre mot de passe a bien été réinitialisé !"
      />

      <Link
        to="/connexion"
        className={cn(buttonVariants({ variant: "default" }))}
      >
        Continuer
      </Link>
    </div>
  );
};

export default ResetPasswordSuccessPage;
